// momentConfig.ts
import moment from "moment";
import "moment/locale/pt-br";

// seta locale global
moment.locale("pt-br");

export default moment;